<template>
  <ChecklistTableTaskCellWrapper :clickable="isCurrentUserPm"
                                 data-locator="responsibles-area"
                                 @click="onEditResponsibles"
  >
    <div class="ChecklistTableTaskResponsibles">
      <template v-if="responsiblesList.length > 0">
        <div class="d-flex flex-column">
          <template v-for="item in responsiblesList" :key="item.id">
            <span>{{ item.name || item.fullName }}</span>
          </template>
        </div>
      </template>
      <template v-else>
        <ChecklistTableTaskEmptyCell />
      </template>
    </div>
  </ChecklistTableTaskCellWrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'
import ChecklistTableTaskEmptyCell from '@/project/checklist/table/ChecklistTableTaskEmptyCell.vue'
import { SET_SHARE_TASKS_DIALOG } from '@/store/modules/checklist/mutation_types'

export default {
  name: 'ChecklistTableTaskResponsibles',
  components: {
    ChecklistTableTaskCellWrapper,
    ChecklistTableTaskEmptyCell,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
    responsiblesList () {
      const responsiblesUsers = this.item.rights?.responsibles?.users || []
      const responsiblesGroups = this.item.rights?.responsibles?.groups || []

      return [...responsiblesUsers, ...responsiblesGroups]
    },
  },
  methods: {
    ...mapMutations('checklist', [SET_SHARE_TASKS_DIALOG]),
    async onEditResponsibles () {
      if(!this.isCurrentUserPm) return

      this.SET_SHARE_TASKS_DIALOG({
        isOpen: true,
        tasksToShare: [this.item],
      })
    },
  },
}
</script>

<style scoped lang="scss">
.ChecklistTableTaskResponsibles {
  display: flex;
  flex-direction: column;
}
</style>
